<template>
    <div>
        <div class="niigmiinTvnshlel_table">
            <table width="100%">
                <thead>
                <tr>
                    <th>№</th>
                    <th>САЛБАР</th>
                    <th>ҮЙЛ АЖИЛГААНЫ ЧИГЛЭЛ</th>
                    <th>БАЙГУУЛАГЫН НЭР</th>
                    <th>И-МЭЙЛ ХАЯГ</th>
                    <th>ВЭБ ХУУДАС</th>
                </tr>
                </thead>
                <tbody>
                <tr :key="index" v-for="(baiguullaga, index) in baiguullaguud">
                    <td>
                        <span v-if="current_page == 1">{{index+1}}</span>
                        <span v-else>{{((current_page-1)*9)+(index+1)}}</span>
                    </td>
                    <td>{{baiguullaga.salbar}}</td>
                    <td>{{baiguullaga.chiglel}}</td>
                    <td>{{baiguullaga.baiguullaga}}</td>
                    <td>{{baiguullaga.mail}}</td>
                    <td><a :href="baiguullaga.web" target="_blank">{{baiguullaga.web}}</a></td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="pagenation">
            <Page  @on-change="changeTBaiguullaga"
                   :current-page="current_page"
                   :page-size="9"
                   :total="total"
            />
        </div>
    </div>
</template>
<script>
    import {getAjAhuiNegj} from "../../api/index"
    export default {
        name: 'header',
        components: {

        },
        data () {
            return {
                modal1: false,
                modal2: false,
                baiguullaguud: [],
                current_page:1,
                last_page:1,
                total: 0,
            }
        },
        mounted () {

            this.calldata();
        },
        methods: {
            calldata(){
                this.$isLoading(true);
                getAjAhuiNegj(this.current_page).then(response=>{
                    this.baiguullaguud = response.data.data;
                    this.current_page = response.data.current_page;
                    this.total = response.data.total;
                    this.$isLoading(false);
                }).catch(error => {
                    this.$Loading.error();
                    console.log('ErrorL ', error);
                });
            },
            changeTBaiguullaga(page) {
                this.current_page = page;
                this.calldata();
            },
        },
    }
</script>
